"use client";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/shadcn-components/ui/dialog";
import type {
  TradeOrder,
  VybeDealInternal,
  VybeOrderInternal,
} from "@/vybe-trader-client/trade-history/types";
import HistoryDetailsContent, {
  type HistoryDetailKind,
} from "./HistoryDetailsContent";

export interface HistoryDetailsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  kind: HistoryDetailKind | null;
  position: TradeOrder | null;
  order: VybeOrderInternal | null;
  deal: VybeDealInternal | null;
}

function titleFor(
  kind: HistoryDetailKind,
  position: TradeOrder | null,
  order: VybeOrderInternal | null,
  deal: VybeDealInternal | null
): string {
  switch (kind) {
    case "position":
      return position
        ? `Position ${position.symbol} #${position.ticket}`
        : "Position details";
    case "order":
      return order
        ? `Order ${order.symbol} #${order.ticketNumber}`
        : "Order details";
    case "deal":
      return deal ? `Deal ${deal.symbol} #${deal.ticketNumber}` : "Deal details";
    default:
      return "Details";
  }
}

export default function HistoryDetailsDialog({
  open,
  onOpenChange,
  kind,
  position,
  order,
  deal,
}: HistoryDetailsDialogProps) {
  const show =
    open &&
    kind &&
    ((kind === "position" && position) ||
      (kind === "order" && order) ||
      (kind === "deal" && deal));

  return (
    <Dialog open={!!show} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[80vh] p-4 flex flex-col gap-0">
        <DialogHeader className="pb-2 shrink-0">
          <DialogTitle className="text-lg">
            {kind ? titleFor(kind, position, order, deal) : "Details"}
          </DialogTitle>
        </DialogHeader>
        <div className="overflow-y-auto flex-1 min-h-0 pr-1">
          {kind === "position" && position && (
            <HistoryDetailsContent kind="position" data={position} />
          )}
          {kind === "order" && order && (
            <HistoryDetailsContent kind="order" data={order} />
          )}
          {kind === "deal" && deal && (
            <HistoryDetailsContent kind="deal" data={deal} />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
